module.exports = __webpack_public_path__ + "img/enroll_logo_light.7f7dc01f.svg";